<ng-container *transloco="let convert;">
<div class="disclosure-details edit-posting-form">
  <h3 class="content-card-title d-none d-sm-none d-md-block">{{convert('sellModule.posting.additionalDisclosuresForm.textAdditional')}}</h3>
  <div class="content-card-subtitle__bold mt-2">{{convert('sellModule.posting.additionalDisclosuresForm.textInsideVehicle')}}</div>
  <form class="body mt-2" name="vehicleInfoInDisclosure" [formGroup]="vehicleInfoInDisclosureForm" nonvalidate>
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="control-wrapper mt-3">
          <div class="custom-control custom-radio custom-control-inline ">
            <input type="radio" id="smokedInsideVehicleRadioYes" name="smokerFlag"
              class="custom-control-input"
              [attr.aria-label]="convert('sellModule.posting.additionalDisclosuresForm.ariaLabelSmokeYes')"
              formControlName="smokerFlag"
              (change)="trackFormChanges()"
              [value]="true" />
            <label class="custom-control-label " for="smokedInsideVehicleRadioYes">{{convert('common.btnYes')}}</label>
          </div>
        </div>
        <div class="control-wrapper mt-3">
          <div class="custom-control custom-radio custom-control-inline ">
            <input type="radio" id="smokedInsideVehicleRadioNo" name="smokerFlag"
              class="custom-control-input"
              [attr.aria-label]="convert('sellModule.posting.additionalDisclosuresForm.ariaLabelSmokeNo')"
              formControlName="smokerFlag"
              (change)="trackFormChanges()"
              [value]="false" />
            <label class="custom-control-label " for="smokedInsideVehicleRadioNo">{{convert('common.btnNo')}}</label>
          </div>
        </div>
        <div class="control-wrapper mt-3">
          <div class="custom-control custom-radio custom-control-inline ">
            <input type="radio" id="smokedInsideVehicleRadio" name="smokerFlag"
              class="custom-control-input"
              formControlName="smokerFlag"
              [attr.aria-label]="convert('sellModule.posting.additionalDisclosuresForm.ariaLabelSmokeDontKnow')"
              (change)="trackFormChanges()"
              [value]="null" />
            <label class="custom-control-label " for="smokedInsideVehicleRadio">{{convert('sellModule.posting.additionalDisclosuresForm.labelDontknow')}}</label>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-5 inspection-comments-section">
        <div class="form-group col-md-6">
          <label>{{convert('sellModule.posting.additionalDisclosuresForm.labelInspectionOptional')}}</label>
          <textarea id="disclosure_inspection_comments" class="form-control seller-updates__form-question"
           [maxLength]="maxInspectionCmtsLength"
           [attr.aria-label]="convert('sellModule.posting.additionalDisclosuresForm.ariaLabelInspectionComments')"
           formControlName="inspectionComments"
           appCharacterCount
           (change)="trackFormChanges()"
           #inspectionInputCount="appCharacterCount"></textarea>
          <app-character-count
            [count]="inspectionInputCount.count$ | async"
            [maxLength]="maxInspectionCmtsLength"
            [characterCountTranslate]="characterCountData">
          </app-character-count>
        </div>
      </div>
    </div>
  </form>
</div>
</ng-container>
